import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import LoginAgain from './views/LoginAgain.vue'
import Survey from './views/Survey.vue'
import Start from './views/Start.vue'
import Edit from './views/Edit.vue'
import TakeAgain from './views/TakeAgain.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/create',
            name: 'login',

            component: Login
        },
        {
            path: '/survey',
            name: 'survey',
            component: Survey
        },
        {
            path: '/start',
            name: 'start',
            component: Start
        },
        {
            path: '/login',
            name: 'login_again',
            component: LoginAgain
        },
        {
            path: '/edit',
            name: 'edit',
            component: Edit
        },
        {
            path: '/take-again',
            name: 'take_again',
            component: TakeAgain
        }
    ]
})
